module.exports = "<i-feather\n  [name]=\"name\"\n  [class]=\"'wh' + size\"\n  [ngClass]=\"iconClass\"\n></i-feather>\n"